import type { RouteRecordRaw } from 'vue-router'
import { PROFILE_ROUTE_NAME } from './constants'

export const profileRoutes: RouteRecordRaw[] = [
  {
    path: '/profile',
    name: PROFILE_ROUTE_NAME,
    component: () => import('./pages/ProfilePage.vue'),
    meta: { requiresAuth: true }
  }
]
